// import { useState } from 'react';
// import { useSelector } from 'react-redux';
// import { useParams } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';

// import LoginForm from 'components/LoginForm/LoginForm';
// import FormContainer from 'uI/FormContainer/FormContainer';
import Submenu from 'uI/Submenu/Submenu';

// import classes from './Chat.module.css';

const Chat = () => {
  return (
    <>
      <Submenu sectionTitle="Asistente UDC" menu={false} />
    </>
  );
};

export default Chat;
